import { useEffect, useState, useSyncExternalStore } from "react";
import {
  prefersDark,
  readStoredTheme,
  resolveTheme,
  storeTheme,
  subscribeToColorScheme,
} from "../lib/theme";

export function useTheme() {
  const [preference, setPreference] = useState(() => readStoredTheme() ?? "system");

  // Mesmo motivo de useSidebarCollapsed: useSyncExternalStore relê a média
  // logo depois de assinar, e é isso que salva a troca de tema do SO que
  // acontece entre o primeiro render e a assinatura.
  const systemPrefersDark = useSyncExternalStore(subscribeToColorScheme, prefersDark);

  useEffect(() => {
    storeTheme(preference);
  }, [preference]);

  return {
    preference,
    resolved: resolveTheme(preference, systemPrefersDark),
    setPreference,
  };
}
